function SideNavigation(targetDom){

	this.$target = $(targetDom);
	this.openFlag = false;

	this.$sideNavigationIcon = $('.side-navigation-icon');
	this.$sideNavigationOpen = $('.side-navigation-open');
	this.$sideNavigationBg = $('.side-navigation-bg');

	var self = this;
	this.$target.on('click',function(){
		self.action(self);
	});
}

SideNavigation.prototype = {
	action : function(G){
		if (G.openFlag){
			G.openFlag = false;
			G.$sideNavigationIcon.removeClass('open');
			G.$sideNavigationOpen.removeClass('open');
			G.$sideNavigationBg.removeClass('open');
		}else if(!G.openFlag){
			G.openFlag = true;
			G.$sideNavigationIcon.addClass('open');
			G.$sideNavigationOpen.addClass('open');
			G.$sideNavigationBg.addClass('open');
		}
	}
};

module.exports = SideNavigation;


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/side_navigation.js
 ** module id = 3
 ** module chunks = 5
 **/